// Selector de diagnóstico CIE-10 para los formularios discretos del Grupo 4
// que crean un `Condition` (016, 113/114/115, 116-cert) — reusa
// el mismo mecanismo YA construido y verificado en vivo para el Grupo 1
// (`ValueSetCombobox` contra el ValueSet real `cie10-minimo`), en vez de
// portar el catálogo estático + Autocomplete de Mantine
// (packages/hce/src/hce/diagnostico/SelectorDiagnosticoCie10.tsx) — mismo
// criterio de "un solo mecanismo de CIE-10 en toda la app" que ya aplica
// pdfFormularioGenerico/PanelFirmaImpresion para la firma.
import type { CodeableConcept } from '@medplum/fhirtypes';
import { useMedplum } from '@medplum/react-hooks';
import type { JSX } from 'react';
import { Label } from '@/components/ui/label';
import { type OpcionValueSet, ValueSetCombobox } from '../ValueSetCombobox';

const SISTEMA_CIE10 = 'http://logiacare.ec/fhir/CodeSystem/cie10-minimo';
const VALUESET_CIE10 = 'http://logiacare.ec/fhir/ValueSet/cie10-minimo';

export interface DiagnosticoCie10Valor {
  /** A guardar en Condition.code.text — texto libre o "descripción" del catálogo. */
  texto: string;
  /** Solo si `texto` matcheó un código real del catálogo — null = texto libre sin código. */
  cie10: OpcionValueSet | null;
}

export function codeDeDiagnostico(valor: DiagnosticoCie10Valor): CodeableConcept {
  const text = valor.texto.trim();
  if (!valor.cie10) return { text };
  return { text, coding: [{ system: valor.cie10.system ?? SISTEMA_CIE10, code: valor.cie10.code, display: valor.cie10.display }] };
}

export interface SelectorDiagnosticoCie10Props {
  readonly label: string;
  readonly value: DiagnosticoCie10Valor;
  readonly onChange: (valor: DiagnosticoCie10Valor) => void;
}

export function SelectorDiagnosticoCie10({ label, value, onChange }: SelectorDiagnosticoCie10Props): JSX.Element {
  const medplum = useMedplum();

  return (
    <div className="flex flex-col gap-1">
      <Label>{label}</Label>
      <ValueSetCombobox
        medplum={medplum}
        binding={VALUESET_CIE10}
        placeholder={label}
        valor={value.texto ? { code: value.cie10?.code ?? '', display: value.texto, system: value.cie10?.system } : null}
        onChange={(opcion) => {
          if (!opcion) {
            onChange({ texto: '', cie10: null });
            return;
          }
          onChange({ texto: opcion.display, cie10: opcion.code ? opcion : null });
        }}
      />
    </div>
  );
}
